import React from "react";

import RecorderService from "./RecorderService";

class AudioRecorder extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    console.log("AudioRecorder constructor");
    this.state = {
      //audioSrc: null,
      //audioType: '',
      //audioOutput: null // for returning blob
      //isRecording: false,
      //recording_status: props.recording_status
    };
    this.recording_status = props.recording_status;
    this.isRecording = false;
    //this.audioSrc = null; // local in-browser blob URL
    //this.audioType = '';
    this.recorderSrvc = null;

    //this.current_slide = null;
    //if (props.current_slide) {
    //  this.current_slide = props.current_slide;
    //}
  }

  componentWillUnmount() {
    this._isMounted = false;
    console.log("AudioRecorder componentWillUnmount");
    // disconnect things!
    //this.setState({ audioSrc: null, audioOutput: null });
    //this.handleStopRecording();
    if (this.recorderSrvc) {
      this.recorderSrvc.stopRecording();
      //this.recorderSrvc.cleanupThings();
    }
    this.recorderSrvc = null;
  }
  
  
  // componentWillMount() {
  //   console.log("componentWillMount");
  // }
  
  componentDidMount() {
    this._isMounted = true;
  }
  
  
  componentDidUpdate() {
    //console.log("componentDidUpdate",this.recording_status,this.props.recording_status);
    if (this.recording_status !== this.props.recording_status) {
      this.changeRecordingStatus(this.recording_status,this.props.recording_status);
    }    
  }
  
  changeRecordingStatus(prev_recording_status,new_recording_status) {
    console.log("AudioRecorder changeRecordingStatus",prev_recording_status,new_recording_status);
    if (prev_recording_status === null && new_recording_status === 'recording') {
      // start recording at first slide
      this.handleStartRecording();
    } else if (prev_recording_status === 'recording' && new_recording_status === 'nextslide') {
      // finish one slide then start recording the next slide
      this.handleNextSlide();
    } else if (prev_recording_status === 'recording' && new_recording_status === 'finishslide') {
      // finish one slide then stop recording
      this.handleFinishSlide();
    } else if (prev_recording_status === 'recording' && new_recording_status === 'paused') {
      // pause recording - reset to beginning of current slide
      this.handlePauseRecording();
    } else if (prev_recording_status === 'paused' && new_recording_status === 'recording') {
      // unpause recording - start recording from beginning of slide
      this.handleUnpauseRecording();
    } else if (prev_recording_status === 'inactive' && new_recording_status === 'recording') {
      // this is a restart of entire thing
      //this.setState({ audioSrc: null, audioOutput: null });
      this.recorderSrvc = null;
      this.handleStartRecording();
    } else if (new_recording_status === 'inactive') {
      // finish entire presentation - only allowed from a paused state
      this.handleStopRecording();
    }
    this.recording_status = new_recording_status;
  }
  
  async handleStartRecording () {
    console.log("AudioRecorder handleStartRecording");
    if (!this.recorderSrvc) {
      console.log("AudioRecorder Creating new RecorderService");
      this.recorderSrvc = new RecorderService();
      this.recorderSrvc.em.addEventListener('recording', (evt) => this._onNewRecording(evt));
    }
    //this.recorderSrvc = new RecorderService();
    let success = await this.recorderSrvc.startRecording();
    if (success === false) {
      this.recorderSrvc.cleanupThings();
      this.recording_status = null;
      this.props.failureCallback();
    } else {
      console.log("AudioRecorder handleStartRecording STARTED");
      this.isRecording = true;
      this.props.startCallback();
    }
    //this.setState({ isRecording: true });
  }
  
  async handlePauseRecording() {
    console.log("AudioRecorder handlePauseRecording");
    //await this.recorderSrvc.pauseRecording();

    if (this.recorderSrvc) {
      //await this.recorderSrvc.pauseRecording()
      //this.recorderSrvc.cleanupThings();
      //this.recorderSrvc = null;
      this.recorderSrvc.softStopRecording();
    }

    this.props.pauseCallback();
    //this.setState({ isRecording: false });
  }
  
  async handleUnpauseRecording() {
    console.log("AudioRecorder handleUnpauseRecording");
    //await this.recorderSrvc.unpauseRecording();
    //this.isRecording = true;
    
    if (!this.recorderSrvc) {
      console.log("AudioRecorder handleUnpauseRecording Creating new RecorderService");
      this.recorderSrvc = new RecorderService();
      this.recorderSrvc.em.addEventListener('recording', (evt) => this._onNewRecording(evt));
    }
    //this.recorderSrvc = new RecorderService();
    await this.recorderSrvc.startRecording();
    console.log("AudioRecorder handleUnpauseRecording STARTED");
    
    this.props.unpauseCallback();
    //this.setState({ isRecording: true });
  }
  
  async handleStopRecording() {
    console.log("AudioRecorder handleStopRecording");
    if (!this.recorderSrvc) {
      this.recorderSrvc = new RecorderService();
    }

    let complete_mp3_blob = await this.recorderSrvc.concatSlideAudio(this.props.audioOutput_array);
    let complete_mp3_blobUrl = window.URL.createObjectURL(complete_mp3_blob);
    
    if (this.recorderSrvc) {
      this.recorderSrvc.cleanupThings();
      this.recorderSrvc = null;
    }
    
    this.props.stopCallback(complete_mp3_blob,complete_mp3_blobUrl,'audio/wav');
  }
  
  // JBB - handleNextSlide is NOT being used atm
  async handleNextSlide() {
    console.log("AudioRecorder handleNextSlide");
    if (this.recorderSrvc) {
      this.recorderSrvc.stopRecording();
    }
    //this.isRecording = false;
    //await this.recorderSrvc.startRecording();
    //console.log("AudioRecorder handleNextSlide Recording STARTED");
    this.props.nextSlideCallback();
  }
  
  async handleFinishSlide() {
    console.log("AudioRecorder handleFinishSlide");
    if (this.recorderSrvc) {
      this.recorderSrvc.stopRecording();
    }
    this.props.finishSlideCallback();
  }

  _onNewRecording (evt) {
    console.log("AudioRecorder _onNewRecording",evt);
    // trying to handle unmount cleanup better
    if (this.recorderSrvc) {
      //this.setState({
      //  audioSrc: evt.detail.recording.blobUrl,
      //  audioType: evt.detail.recording.mimeType,
      //});
      this.props.finishCallback(evt.detail.recording.blob,evt.detail.recording.blobUrl,evt.detail.recording.mimeType);
    } else {
      // no nothing...we are in cleanup mode
    }
      
    //this.audioSrc = evt.detail.recording.blobUrl
    //this.audioType = evt.detail.recording.mimeType
    
    /*
    if (!this.saveNextRecording) {
      return
    }
    const newIdx = this.recordingsCont.childNodes.length + 1

    const newEl = document.createElement('div')
    newEl.innerHTML = '<audio id="audio-recording-' + newIdx + '" controls></audio>'
    this.recordingsCont.appendChild(newEl)

    const recordingEl = document.getElementById("audio-recording-" + newIdx);
    recordingEl.src = evt.detail.recording.blobUrl
    recordingEl.type = evt.detail.recording.mimeType
    */
  }
  
  render() {
    return "";
  }
  /*
  render() {
    console.log("AudioRecorder render",this.state,this.props,this.isRecording,this.recording_status);
    let audio_element = null;
    if (this.state.audioSrc) {
      audio_element = React.createElement("audio", {
        style: {width: "100%"},
        controls: true,
        src: this.state.audioSrc,
        type: this.state.audioType,
        onSeeked: this.props.audioSeekCallback(),
        onPause: this.props.audioPauseCallback(),
        onPlay: this.props.audioStartCallback(),
        ref: this.props.audioRef
      })
    }
    return (
      <div>
      <span>{this.props.slide_indicator}<br/></span>
      {audio_element}
      </div>
    );
  }
  */
}
      /*
      <div>
        AudioRecorder Start<br/>
        isRecording: {this.isRecording}<br/>
        recording_status: {this.recording_status}<br/>
        AudioRecorder End<br/>
        {audio_element}
      </div>
      */

export default AudioRecorder;
/*
"use strict";

class App {
  constructor () {
    this.btnRecord = document.getElementById('btn-record');
    this.btnStop = document.getElementById('btn-stop');

    this.debugTxt = document.getElementById('debug-txt')

    this.recordingsCont = document.getElementById('recordings-cont')

    this.isRecording = false
    this.saveNextRecording = false

    this.debugTxt.innerHTML = "stopped"
  }

  init () {
    this._initEventListeners()
  }

  _initEventListeners () {

    this.btnRecord.addEventListener('click', evt => {
      this._stopAllRecording()
      this.saveNextRecording = true
      this._startRecording()

      this.btnRecord.disabled = true
      this.btnStop.disabled = false
      this.debugTxt.innerHTML = "recording"
    })

    this.btnStop.addEventListener('click', evt => {
      this._stopAllRecording();

      this.btnRecord.disabled = false
      this.btnStop.disabled = true
      this.debugTxt.innerHTML = "stopped"
    })
  }

  _startRecording () {
    if (!this.recorderSrvc) {
      this.recorderSrvc = new RecorderService()
      this.recorderSrvc.em.addEventListener('recording', (evt) => this._onNewRecording(evt))
    }

    if (!this.webAudioPeakMeter) {
      this.webAudioPeakMeter = new WebAudioPeakMeter()
      this.meterEl = document.getElementById('recording-meter')
    }

    this.recorderSrvc.onGraphSetupWithInputStream = (inputStreamNode) => {
      this.meterNodeRaw = this.webAudioPeakMeter.createMeterNode(inputStreamNode, this.recorderSrvc.audioCtx)
      this.webAudioPeakMeter.createMeter(this.meterEl, this.meterNodeRaw, {})
    }

    this.recorderSrvc.startRecording()
    this.isRecording = true
    this.debugTxt.innerHTML = "recording..."
  }

  _stopAllRecording () {
    if (this.recorderSrvc && this.isRecording) {

      this.recorderSrvc.stopRecording()
      this.isRecording = false

      if (this.meterNodeRaw) {
        this.meterNodeRaw.disconnect()
        this.meterNodeRaw = null
        this.meterEl.innerHTML = ''
      }
    }
  }

  _onNewRecording (evt) {
    if (!this.saveNextRecording) {
      return
    }
    const newIdx = this.recordingsCont.childNodes.length + 1

    const newEl = document.createElement('div')
    newEl.innerHTML = '<audio id="audio-recording-' + newIdx + '" controls></audio>'
    this.recordingsCont.appendChild(newEl)

    const recordingEl = document.getElementById("audio-recording-" + newIdx);
    recordingEl.src = evt.detail.recording.blobUrl
    recordingEl.type = evt.detail.recording.mimeType
  }
}
*/